import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress clone page — permanently redirect to the canonical post.
export const Route = createFileRoute("/clone-of-do-hair-plugs-look-natural")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/do-hair-plugs-look-natural/", location.searchStr), statusCode: 301 });
  },
});
